import * as React from 'react';
import './style.css';

export interface NotFoundProps {
  path?: string;
}

export interface NotFoundState {
  /* empty*/
}

export class NotFound extends React.Component<NotFoundProps, NotFoundState> {
  render() {
    const { path } = this.props;

    return (
      <main className="not-found" role="main">
        <p className="not-found-message">
          Sorry, we couldn't find anything {path ? `at ${path}` : `here`}
          <br />
          <br />
          <br />
          Please check the URL and try again
        </p>
      </main>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/app/components/App/NotFound/index.tsx